import * as React from "react"

// some domains don't have logos on Clearbit, so we map them to an alternate domain that will show the right logo
const logoOverrides = {
  // Levi's
  "https://www.levi.com/": "levistrauss.com",
  "levi.com": "levistrauss.com",
  "Levis.com": "levistrauss.com",
} as const
export type LogoOverrideKeys = keyof typeof logoOverrides
//
const staticImages = {
  "static-google": "/static-logos/google.png",
  "static-google-ads": "/static-logos/google-abs.png",
  "static-klaviyo": "/static-logos/klaviyo.png",
  "static-tiktok": "/static-logos/tiktok.png",
  "static-pinterest": "/static-logos/pinterest.png",
  "static-facebook": "/static-logos/facebook.png",
  "static-influencer": "/static-logos/influencer.png",
  "https://shop.lululemon.com/": "/static-logos/lululemon.png",
  "lululemon.com": "/static-logos/lululemon.png",
  "madebymary.com": "/static-logos/made-by-mary.webp",
  "ivycityco.com": "/static-logos/ivy-city.png",
} as const
export type StaticImagesKeys = keyof typeof staticImages

function isUrlInOverrides(url: string): url is LogoOverrideKeys {
  if (url in logoOverrides) return true
  return false
}
function isUrlInStaticImages(url: string): url is StaticImagesKeys {
  if (url in staticImages) return true
  return false
}

// uses the Clearbit logo API which requires attribution
export default function CompanyLogo({
  url,
  customStyle,
  ...props
}: {
  url: string
  customStyle?: object
}) {
  // provides a fallback image onError if Clearbit returns an error
  const imgRef = React.useRef<HTMLImageElement>(null)

  let logoUrl = `//logo.clearbit.com/${url}`
  if (isUrlInOverrides(url)) {
    logoUrl = `//logo.clearbit.com/${logoOverrides[url]}`
  }
  // lastly check our folder of static images that won't change based on Clearbit
  if (isUrlInStaticImages(url)) {
    logoUrl = staticImages[url]
  }

  return (
    <img
      ref={imgRef}
      style={{
        maxWidth: 36,
        maxHeight: 36,
        color: "#333",
        fontSize: 8,
        overflow: "hidden",
        borderRadius: 3,
        ...customStyle,
      }}
      src={logoUrl}
      alt={`Logo for ${url}`}
      onError={() => {
        if (imgRef.current) {
          imgRef.current.src = "/fallback-image.png"
        }
      }}
      {...props}
    />
  )
}
